import { render, staticRenderFns } from "./InjectionMachineAdd.vue?vue&type=template&id=dcb06800&"
import script from "./InjectionMachineAdd.vue?vue&type=script&lang=js&"
export * from "./InjectionMachineAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports